module.exports = __webpack_public_path__ + "src/assets/ch.9b440836.png";